// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/complication */
export async function complicationControllerUpdate(
	body: API.ComplicationUpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/complication', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/complication/${param0} */
export async function complicationControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.ComplicationControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.ComplicationViewResponse>(`/api/complication/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/complication/${param0} */
export async function complicationControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.ComplicationControllerCreateParams,
	body: API.ComplicationCreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/complication/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 DELETE /api/complication/${param0}/${param1} */
export async function complicationControllerDelete(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.ComplicationControllerDeleteParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, id: param1, ...queryParams } = params;
	return request<boolean>(`/api/complication/${param0}/${param1}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}
